import { render, staticRenderFns } from "./HotpPic.vue?vue&type=template&id=7a5a44b3&scoped=true"
import script from "./HotpPic.vue?vue&type=script&lang=js"
export * from "./HotpPic.vue?vue&type=script&lang=js"
import style0 from "./HotpPic.vue?vue&type=style&index=0&id=7a5a44b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5a44b3",
  null
  
)

export default component.exports